/* eslint-disable import/no-mutable-exports */

let buildHash: string | null = null
try {
  buildHash = process.env.NEXT_VERSION_HASH ?? ''
} catch (_) {
  // No op
}
if (buildHash === '') {
  buildHash = null
}

let buildDate: string | null = null
try {
  buildDate = process.env.NEXT_VERSION_DATETIME ?? ''
} catch (_) {
  // No op
}
if (buildDate === '') {
  buildDate = null
}

export { buildHash, buildDate }

export const UPDATE_LOCKS = new Set()
